import axios from './AxiosInstance'

export default {
  fetch: ({ targetID }) => {
    return new Promise((resolve, reject) => {
      axios.httpClient({
        method: 'get',
        url: '/api/address_exchange_token',
        headers: {
          'X-HTTP-Method-Override': 'GET',
        },
        params: { id: targetID },
        withCredentials: true
      }).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  create: ({ addressCategoryID }) => {
    let formData = new FormData()
    formData.append('address_category_id', addressCategoryID)
    return new Promise((resolve, reject) => {
      axios.currentCsrfToken().then(token => {
        axios.httpClient({
          method: 'post',
          url: '/api/address_exchange_token',
          headers: {
            'X-HTTP-Method-Override': 'POST',
            'Content-Type': 'multipart/form-data',
            'X-CSRF-TOKEN': token
          },
          withCredentials: true,
          data: formData
        }).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      }).catch(err => { reject(err) })
    })
  },

  exchange: ({ addressCategoryID, token }) => {
    let formData = new FormData()
    formData.append('address_category_id', addressCategoryID)
    formData.append('token', token)
    return new Promise((resolve, reject) => {
      axios.currentCsrfToken().then(token => {
        axios.httpClient({
          method: 'put',
          url: '/api/address_exchange_token/exchange',
          headers: {
            'X-HTTP-Method-Override': 'PUT',
            'Content-Type': 'multipart/form-data',
            'X-CSRF-TOKEN': token
          },
          withCredentials: true,
          data: formData
        }).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      }).catch(err => { reject(err) })
    })
  },

}